import React, { FC } from 'react';
import EmptyState, { CommonEmptyStateProps } from '../../EmptyState';
import noMatch from './noMatch.svg';

export const NoMatch: FC<React.PropsWithChildren<CommonEmptyStateProps>> = (props) => (
  <EmptyState imageHeight={198} imageWidth={426} imageSrc={noMatch} {...props} />
);
